/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptInvitationRequest
 */
export interface AcceptInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptInvitationRequest
     */
    inviteToken: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptInvitationRequest
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptInvitationRequest
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptInvitationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptInvitationRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptInvitationRequest
     */
    phoneNumberExtension: string;
}

/**
 * Check if a given object implements the AcceptInvitationRequest interface.
 */
export function instanceOfAcceptInvitationRequest(value: object): value is AcceptInvitationRequest {
    if (!('inviteToken' in value) || value['inviteToken'] === undefined) return false;
    if (!('emailAddress' in value) || value['emailAddress'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('phoneNumberExtension' in value) || value['phoneNumberExtension'] === undefined) return false;
    return true;
}

export function AcceptInvitationRequestFromJSON(json: any): AcceptInvitationRequest {
    return AcceptInvitationRequestFromJSONTyped(json, false);
}

export function AcceptInvitationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'inviteToken': json['inviteToken'],
        'emailAddress': json['emailAddress'],
        'password': json['password'],
        'name': json['name'],
        'phoneNumber': json['phoneNumber'],
        'phoneNumberExtension': json['phoneNumberExtension'],
    };
}

  export function AcceptInvitationRequestToJSON(json: any): AcceptInvitationRequest {
      return AcceptInvitationRequestToJSONTyped(json, false);
  }

  export function AcceptInvitationRequestToJSONTyped(value?: AcceptInvitationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inviteToken': value['inviteToken'],
        'emailAddress': value['emailAddress'],
        'password': value['password'],
        'name': value['name'],
        'phoneNumber': value['phoneNumber'],
        'phoneNumberExtension': value['phoneNumberExtension'],
    };
}

